export const TOOLBAR_HEIGHT = 48;
export const WIDGET_ACTION_MENU_WIDTH_THRESHOLD = 350;
export const TOOLBAR_HIDDEN_HEIGHT = 0;
